module.exports = __webpack_public_path__ + "img/74ffdab.png";